export default class userGroup {
    /** @ngInject */
    constructor($http, config) {
        this.urlBase = config.accountsApiUrl + '/api/v1';
        this.dependencies = {
            $http: $http
        };

        this.get();
    }

    get() {
        let request = {
            url: `${this.urlBase}/user/group`,
            method: 'GET'
        };

        this.dependencies.$http(request).then((response) => {
            angular.extend(this, response.data);
        });
    }
}



// WEBPACK FOOTER //
// ./user/services/user-group.js